import styled from 'styled-components';
import { Text } from '@village/ui';

export const ParticipantList = styled(Text)`
    width: 100%;
    padding: 0 4px;
`;